import LangSwitcher from "@app/dashboard/components/outer_layout/LangSwitcher";
import PromoSection from "@app/dashboard/components/outer_layout/PromoSection";
import type { IOuterLayout } from "@app/dashboard/types/outerLayout";
import styles from "./outer-layout.module.scss";

import paymobLogoPng from '@app/dashboard/assets/images/shared/paymob-white.png';
import paymobLogoWebp from '@app/dashboard/assets/images/shared/paymob-white.webp';
import paymobArrow from '@app/dashboard/assets/images/outerLayout/paymob-arrow.svg';


const OuterLayout = ({ children }: IOuterLayout) => {
  return (
    <div className={styles['outer-layout']}>
      <section className={styles['outer-layout__left-panel']}>
        <header className={styles['outer-layout__left-panel__header']}>
          <picture>
            <source srcSet={paymobLogoWebp} type="image/webp" />
            <img
              className={styles['outer-layout__left-panel__header__logo']}
              src={paymobLogoPng}
              alt="Paymob logo"
            />
          </picture>
        </header>

        <img src={paymobArrow} className={styles['outer-layout__left-panel__illustration']} aria-hidden />
      
        <PromoSection />
      </section>

      <section className={styles['outer-layout__right-panel']}>
        <header className={styles['outer-layout__right-panel__header']}>
          <LangSwitcher />
        </header>
        <div className={styles['outer-layout__right-panel__body']}>
          <div className={styles['outer-layout__right-panel__content']}>
            {children}
          </div>
        </div>
      </section>
    </div>
  )
}

export default OuterLayout;